import script from "./ManualTimeAdminRequired.vue?vue&type=script&setup=true&lang=js"
export * from "./ManualTimeAdminRequired.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__